export const formFields = [
  {
    section: "General Information",
    name: "tscScheduleName",
    label: "Schedule",
    fieldLabel: "Wrk TSC Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [1, 14],
  },
  {
    section: "General Information",
    name: "tscDescription",
    label: "Description",
    fieldLabel: "TSC Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [2, 29],
  },
  {
    section: "General Information",
    name: "tscVersion",
    label: "Version",
    fieldLabel: "TSC Version",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 2, message: "MAXLENGTH_2" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [3, 65],
  },
  {
    section: "General Information",
    name: "tscDispOutdatedRcds",
    label: "Display",
    fieldLabel: "DSC Disp Outdated Rcds?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [4, 78],
  },
  {
    section: "General Information",
    name: "tscStepCount",
    label: "Steps",
    fieldLabel: "TSC Step Count",
    type: "number",
    fractionDigits: 0,
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 14],
  },
  {
    section: "General Information",
    name: "tscCrossOverFlag",
    label: "Cross Over",
    fieldLabel: "TSC Cross Over Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 14],
  },
  {
    section: "General Information",
    name: "tscTroopAccumCompCode",
    label: "TrOOP Accumulation Code",
    fieldLabel: "TSC Troop Accum Comp Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 2, message: "MAXLENGTH_2" },
    },
    fieldNature: "Add: Read-only, Change: Editable, View: Read-only",
    position: [8, 31],
  },
  {
    section: "General Information",
    name: "tscDrugSpendAccumComp",
    label: "Drug Spend Accumulation Code",
    fieldLabel: "TSC Drug Spend Accum Comp",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [9, 31],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },
  {
    section: "General Information",
    name: "tscCoverageGapCalc",
    label: "Coverage Gap Calculation",
    fieldLabel: "TSC Coverage Gap Calc",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 32],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },
  {
    section: "Part B(Header)",
    name: "tscPartBAccumType",
    label: "Accumulation Type",
    fieldLabel: "TSC Part B Accum Type",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 22],
  },
  {
    section: "Part B(Header)",
    name: "tscPartBAlternateSch",
    label: "Alternate Schedule",
    fieldLabel: "TSC Part B Alternate Sch",
    type: "lookup",
    externalProgram: { default: "RCTSC003" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "tscPartBAlternateSch",
            target: "tscScheduleName",
            legacy: "tscScheduleName",
          },
          {
            source: "tscPartBAlternateSchDesc",
            target: "tscDescription",
            legacy: "tscDescription",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 22],
  },

  {
    section: "Part B(Header)",
    name: "tscPartBAlternateSchDesc",
    label: "",
    fieldLabel: "TSC PARTB ALTERNATE SCH DESC",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [13, 33],
  },

  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpAccumCompCode",
    label: "Accumulation Component Code",
    fieldLabel: "TSC EGWP Accum Comp Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 30],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },
  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpNetworkAccum",
    label: "Network Accumulation",
    fieldLabel: "TSC EGWP Network Accum",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 30],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },
  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpCombTroopSched",
    label: "Combined Schedule",
    fieldLabel: "TSC EGWP Comb TROOP Sched",
    type: "lookup",
    externalProgram: { default: "RCTSC003" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "tscEgwpCombTroopSched",
            target: "tscScheduleName",
            legacy: "tscScheduleName",
          },
          {
            source: "tscEgwpCombTroopSchedDesc",
            target: "tscDescription",
            legacy: "tscDescription",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 30],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },

  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpCombTroopSchedDesc",
    label: "",
    fieldLabel: "TSC EGWP COMB TROOP SCHED DESC",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [17, 46],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },

  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpSplitTroopSch",
    label: "Split Schedule",
    fieldLabel: "TSC EGWP Split TROOP Sch",
    type: "lookup",
    externalProgram: { default: "RCTSC003" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "tscEgwpSplitTroopSch",
            target: "tscScheduleName",
            legacy: "tscScheduleName",
          },
          {
            source: "tscEgwpSplitTroopSchDesc",
            target: "tscDescription",
            legacy: "tscDescription",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 30],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },

  {
    section: "EGWP MOOP(Header)",
    name: "tscEgwpSplitTroopSchDesc",
    label: "",
    fieldLabel: "TSC EGWP SPLIT TROOP SCH DESC",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [18, 46],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["00"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },

  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add:Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add:Non-Display, Change: Read-only, View: Read-only",
    position: [21, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add:Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
];

export const screenInfo = {
  ADD: ["Add TrOOP Schedule", "RCTSC005"],
  CHANGE: ["TrOOP Schedule Detail", "RCTSC002"],
  VIEW: ["TrOOP Schedule Detail", "RCTSC002"],
};
